import { render, staticRenderFns } from "./ScheduleRMPayments.vue?vue&type=template&id=054772d6&scoped=true&"
import script from "./ScheduleRMPayments.vue?vue&type=script&lang=js&"
export * from "./ScheduleRMPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054772d6",
  null
  
)

export default component.exports